import React, { useCallback } from 'react'
import useReactRouter from 'use-react-router'
import Modal from 'core/elements/modal'
import Text from 'core/elements/Text'
import Button from 'core/elements/button'
import useUpdateAction from 'core/hooks/useUpdateAction'
import { routeManager } from 'core/utils/routes'
import { deleteSecret } from './actions'

export default function DeleteSecretDialog({ rows: [secret], onClose }) {
  const { history, match } = useReactRouter()
  const { cluster } = match.params
  const { update: deleteFn, updating: deletingSecret } = useUpdateAction(deleteSecret)
  const handleDelete = useCallback(async () => {
    await deleteFn(secret)
    onClose(true)
    history.push(
      routeManager.routes.kubernetes.resources.secrets.list.path({
        cluster,
      }),
    )
  }, [secret])

  return (
    <Modal
      panel="dialog"
      open
      onClose={onClose}
      title={`Remove Secret "${secret?.name}" ?`}
      maxWidth={600}
      data-testid="delete-secret-modal"
      footer={
        <>
          <Button
            variant="secondary"
            onClick={onClose}
            disabled={deletingSecret}
            data-testid="delete-secret-cancel-button"
          >
            Cancel
          </Button>
          <Button
            onClick={handleDelete}
            loading={deletingSecret}
            data-testid="delete-secret-confirm-button"
          >
            Delete
          </Button>
        </>
      }
    >
      <Text variant="body2" data-testid="delete-secret-warning-text">
        Your data will be lost since this action cannot be undone.
      </Text>
    </Modal>
  )
}
